export const ThemeActionTypes = {
  Theme_DIRECTION: "Theme_DIRECTION",
};
